import * as React from 'react';
import { useTranslation } from 'react-i18next';

// Utils
import { formatCents } from '@src/shared/src/util/general';
// Constants
// Actions
// Models
import { RedeemingAllowanceModel } from '@src/shared/src/models';
// Interfaces
// Components
import { WarningBanner } from '@toolkit/ui';
// Styles
import '../styles/RedeemedSearchNotification.scss';

type Props = {
  redeemingAllowance: RedeemingAllowanceModel;
};

export const RedeemedSearchNotification: React.FC<Props> = ({ redeemingAllowance }) => {
  const { t } = useTranslation();

  if (redeemingAllowance) {
    return (
      <WarningBanner
        type="info"
        label={t('redeemedSearchNotification.message.text', {
          maxPrice: formatCents(redeemingAllowance.maxPrice),
        })}
      />
    );
  }
};
